// import axiosInstance from 'utils/axiosInstance';
// import setAuthToken from 'store/helper/setAuthToken';
import axiosInstance from 'utils/axiosInstance';
import { addSpacesToCamelCase, EMPLOYEE, logoutLocalStorage, setToast, toastConfig } from 'utils/commonUtil';
import { endpoints } from 'endpoints/endpoints';
import { SET_ORG_TYPE, SET_USER_TYPE } from './actions';
// import { useQueryClient } from '@tanstack/react-query';

export const userLoginHelper = (data) => {
  return {
    type: 'SET_USER_AUTH',
    payload: data
  };
};

const userLogoutHelper = (data) => {
  return {
    type: 'DELETE_USERS_DATA',
    payload: data
  };
};

export const userLoginLimitIncrement = () => {
  return {
    type: 'INCREMENT_COUNTER'
  };
};
export const userLoginLimitReset = () => {
  return {
    type: 'RESET_COUNTER'
  };
};

export const userLogin = (loginCredentials, history, setIsLoading, loginLimitCount, loginAttempt) => {
  return async (dispatch) => {
    try {
      setIsLoading(true);

      /**
       * when login api work on this code
       *
       */
      await axiosInstance
        .post(`${endpoints.users}/login`, loginCredentials)
        .then((res) => {
          if (res.status === 200) {
            setIsLoading(false);
            localStorage.setItem('userJwtToken', res?.data?.data?.token);
            // localStorage.setItem(
            //   'userJwtToken',
            //   'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY3N2U2OGJkOTY3YzE1ZjdhYzE1MzA3YiIsInR5cGVzIjpbIk1haW4gUE9DIiwiU2Vjb25kYXJ5IFBPQyJdLCJvcmdhbml6YXRpb25UeXBlcyI6WyJTdXBlckFkbWluIiwiRW50ZXJwcmlzZSIsIlJlY3ljbGVyIiwiUmV0YWlsZXIiLCJSZXNlbGxlciIsIlNlcnZpY2VQcm92aWRlciJdLCJpYXQiOjE3NDQ2MTkyMDMsImV4cCI6MTc3NjE3NjgwM30.uF8HmRmtIYttXii6PURhF6oxjffaKcAS2uKRlJVF0CQ'
            // );
            dispatch(userLoginHelper(res?.data?.data?.user));
            localStorage.setItem('userData', JSON.stringify(res?.data?.data?.user));
            localStorage.setItem('userOrgId', JSON.stringify(res?.data?.data?.user?.id));
            // localStorage.setItem('viewChangeOrgData', JSON.stringify(res?.data?.data?.user));
            localStorage.setItem('isViewChange', 0);

            const organizationTypes = res?.data?.data?.user?.organizationTypes;
            // const rawType = res?.data?.data?.user?.types;
            // const userTypes = rawType === 'Employee' ? EMPLOYEE : rawType;

            const userTypes = res?.data?.data?.user?.types === 'Employee' ? EMPLOYEE : res?.data?.data?.user?.types;
            // console.log('🚀 ~ .then ~ userTypes:', userTypes);
            // console.log('userLogin ~ organizationTypes : ', organizationTypes, ' | userTypes : ', userTypes);
            localStorage.setItem(
              'orgType',
              organizationTypes && Array.isArray(organizationTypes) && organizationTypes.length > 0
                ? addSpacesToCamelCase(organizationTypes[0])
                : null
            );
            localStorage.setItem('userType', userTypes && Array.isArray(userTypes) && userTypes.length > 0 ? userTypes[0] : null);

            toastConfig.type = 'success';
            setToast(toastConfig, res?.data?.message);

            if (loginLimitCount !== null) dispatch(userLoginLimitReset());

            history('/dashboard/default');
          }
        })
        .catch((res) => {
          // console.log('🚀 ~ return ~ resLogin:', res);
          setIsLoading(false);
          toastConfig.type = 'error';

          if (res.response.status === 400 && loginLimitCount !== null && loginAttempt - loginLimitCount === 1) {
            history('/forgot-password', { state: { email: loginCredentials?.credentials?.email } });
            dispatch(userLoginLimitReset());
            setToast(toastConfig, 'Please Reset your password!');
          } else if (res.response.status === 400 && loginLimitCount < 3) {
            dispatch(userLoginLimitIncrement());
            setToast(toastConfig, res?.response?.data?.error);
          } else {
            setToast(toastConfig, res?.response?.data?.error);
          }
        });
      /**
       * when login api work on this code
       *
       */
    } catch (err) {
      if (err.response) {
        // console.log('🚀 ~ return ~ err.response:', err.response);
        const message = { message: err.response.data.message };
        dispatch({
          type: 'SET_LOGIN_ERRORS',
          payload: message
        });
      } else {
        const message = { message: err };

        return message;
      }
    }
  };
};

export const userLogout = (history) => {
  // const queryClient = useQueryClient();
  return (dispatch) => {
    logoutLocalStorage();
    /*localStorage.removeItem('userJwtToken');
    localStorage.removeItem('userData');
    localStorage.removeItem('userOrgId');
    // localStorage.removeItem('userOrgName');
    localStorage.removeItem('userType');
    localStorage.removeItem('orgType');
    localStorage.removeItem('isViewChange');
    localStorage.removeItem('viewChangeOrgName');*/
    dispatch({ type: SET_ORG_TYPE, orgType: '' });
    dispatch({ type: SET_USER_TYPE, userType: '' });
    // setAuthToken(false);
    dispatch(userLogoutHelper({}));
    history('/');
    // queryClient.clear();
  };
};
